import { createSlice } from "@reduxjs/toolkit";

const userSlice = createSlice({
  name: "users",
  initialState: {
    users: "",
    userID: [],
    selectedUser: null,
    userRoles: []
  },

  reducers: {
    getUserList: (state, action) => {
      // console.log(action)
      state.users = action.payload.users;
    },
    setUserID: (state, action) => {
      state.userID = action.payload.userID;
    },
    setStoreSelectedUser: (state, action) => {
      state.selectedUser = action.payload.selectedUser
    },
    setUserRoles: (state, action) => {
      state.userRoles = action.payload.payload
    }
  },
});

export const getUserList = userSlice.actions.getUserList;
export const setUserID = userSlice.actions.setUserID;
export const setStoreSelectedUser = userSlice.actions.setStoreSelectedUser;
export const setUserRoles = userSlice.actions.setUserRoles;
export default userSlice.reducer;
